export type ElfRace = 'High Elf' | 'Dark Elf' | 'Wood Elf' | 'Christmas Elf' | 'Half-Elf'
export type ElfGender = 'Male' | 'Female' | 'Neutral'
export type ElfStyle = 'Classic' | 'Exotic' | 'Ancient'

export interface ElfName {
  name: string
  surname: string
  meaning: string
  pronunciation: string
  background: string
}

const nameData: Record<ElfRace, Record<ElfGender, string[]>> = {
  'High Elf': {
    Male: ['Aelindis', 'Beluar', 'Caladwen', 'Draelor', 'Eldrin', 'Faerand', 'Gaelen', 'Haelon', 'Iorveth', 'Jaelen'],
    Female: ['Aelindra', 'Baelwen', 'Caerwen', 'Daeloeth', 'Elenari', 'Faerith', 'Gaelira', 'Haelari', 'Iriel', 'Jaelara'],
    Neutral: ['Aeon', 'Bael', 'Caer', 'Dael', 'Elen', 'Faer', 'Gael', 'Hael', 'Iri', 'Jae']
  },
  'Dark Elf': {
    Male: ['Drizzt', 'Jarlaxle', 'Zaknafein', 'Malice', 'Rizzen', 'Vorn', 'Dinin', 'Nalfein', 'Durnad', 'Gromph'],
    Female: ['Lolth', 'Viconia', 'Mazzent', 'Quenthel', 'Triel', 'Nedylene', 'Eclavyne', 'Zalyra', 'Malice', 'Viconira'],
    Neutral: ['Drix', 'Jarl', 'Zak', 'Mal', 'Riz', 'Vor', 'Din', 'Nal', 'Dur', 'Grom']
  },
  'Wood Elf': {
    Male: ['Legolas', 'Thranduil', 'Celeborn', 'Haldir', 'Oropher', 'Galion', 'Lindon', 'Erestor', 'Galdor', 'Rohan'],
    Female: ['Tauriel', 'Galadriel', 'Arwen', 'Luthien', 'Celebrian', 'Idril', 'Nimrodel', 'Finduilas', 'Earwen', 'Aredhel'],
    Neutral: ['Leg', 'Thran', 'Cel', 'Hal', 'Oro', 'Gal', 'Lin', 'Ere', 'Gal', 'Roh']
  },
  'Christmas Elf': {
    Male: ['Buddy', 'Bernie', 'Jingle', 'Zippy', 'Pip', 'Snowball', 'Twinkle', 'Dash', 'Blizzard', 'Evergreen'],
    Female: ['Holly', 'Joy', 'Merry', 'Noelle', 'Ginger', 'Sugarplum', 'Candy', 'Mistletoe', 'Star', 'Sparkle'],
    Neutral: ['Elf', 'Toy', 'Gift', 'Bell', 'Frost', 'Candy', 'Snap', 'Crackle', 'Pop', 'Pudding']
  },
  'Half-Elf': {
    Male: ['Tanis', 'Elandir', 'Korth', 'Maelon', 'Dorian', 'Silas', 'Aric', 'Bran', 'Caelum', 'Finn'],
    Female: ['Laurana', 'Alia', 'Elora', 'Kaelie', 'Myra', 'Neryn', 'Sarya', 'Thea', 'Xanthe', 'Zina'],
    Neutral: ['Tan', 'Ela', 'Kor', 'Mae', 'Dor', 'Sil', 'Ari', 'Bra', 'Cae', 'Fin']
  }
}

const meanings: Record<string, string> = {
  Aelindra: 'Starlight of the Dawn',
  Aelindis: 'Star Watcher',
  Legolas: 'Green Leaf',
  Tauriel: 'Daughter of the Forest',
  Drizzt: 'Unwavering Shadow',
  Buddy: 'Cheerful Helper',
  Tanis: 'Bridge of Two Worlds',
  // ... can be expanded
}

import { elfSurnames } from './surnames'

export function generateElfNames(
  race: ElfRace,
  gender: ElfGender,
  style: ElfStyle,
  count: number
): ElfName[] {
  const possibleNames = nameData[race][gender]
  const possibleSurnames = elfSurnames[race] || elfSurnames['High Elf']
  const results: ElfName[] = []
  
  for (let i = 0; i < count; i++) {
    const randomIndex = Math.floor(Math.random() * possibleNames.length)
    const randomSurnameIndex = Math.floor(Math.random() * possibleSurnames.length)
    const name = possibleNames[randomIndex] || 'Aelindra'
    const surname = possibleSurnames[randomSurnameIndex] || 'Moonwhisper'
    
    results.push({
      name,
      surname,
      meaning: `${meanings[name] || 'Noble Spirit'} of House ${surname}`,
      pronunciation: `${name.toLowerCase()} ${surname.toLowerCase()}`,
      background: `A respected ${race} from the lineage of ${surname}, known for ${style.toLowerCase()} deeds.`
    })
  }
  
  return results
}
